import { render, staticRenderFns } from "./FuncionarioDocumento.vue?vue&type=template&id=196267e9"
import script from "./FuncionarioDocumento.vue?vue&type=script&lang=js"
export * from "./FuncionarioDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports